<template>
  <base-order :detail="detail" :statusEnum="statusEnum">
    <div class="button-bottom-wrap" v-if="detail">
      <confirm
        v-model="show"
        title="审核"
        confirm-text="同意"
        cancel-text="拒绝"
        @on-cancel="onCancel"
        @on-confirm="onConfirm"
      >
        <p style="text-align:left;margin: 15px 0">
          业务员：{{ params.auditName }}
        </p>
        <p style="text-align:left;">联系方式：{{ params.auditPhone }}</p>
      </confirm>

      <div class="flex" v-if="detail.status === 3">
        <button
          v-if="rejectValue"
          class="button-bottom button-bottom-reject flex-1"
          @click="reject"
        >
          拒绝
        </button>
        <button class="button-bottom flex-2" @click="ifFinishOrder">
          完成订单
        </button>
      </div>
      <button
        class="button-bottom"
        @click="show = true"
        v-if="detail.status === 1"
      >
        <!-- 加油方式确认 -->审核
      </button>
      <!--      <button-->
      <!--        class="button-bottom"-->
      <!--        @click="finishOrder"-->
      <!--        v-if="detail.status === 7 && detail.paymentMethod == 2"-->
      <!--      >-->
      <!--        完成订单-->
      <!--      </button>-->
    </div>
    <confirm
      v-model="show1"
      title="提示"
      confirm-text="确定"
      cancel-text="取消"
      @on-confirm="onConfirm1"
    >
      <p style="text-align:left;margin: 15px 0">是否完成订单？</p>
      <p
        v-if="allowInfo.finishPay == false"
        style="text-align:left;margin: 15px 0;color: #ff3600"
      >
        尚有货款未结清
      </p>
      <p
        v-if="allowInfo.finishRefueling == false"
        style="text-align:left;margin: 15px 0;color: #ff3600"
      >
        尚有未使用加油量
      </p>
      <group>
        <x-textarea
          style="padding-left: 0;padding-right: 0;border: 1px solid #eee"
          title="备注"
          v-model="finishRemark"
        ></x-textarea>
      </group>
    </confirm>
    <confirm
      v-model="show2"
      title="提示"
      confirm-text="确定"
      cancel-text="取消"
      @on-confirm="onConfirm2"
      :close-on-confirm="false"
    >
      <p style="text-align:left;margin: 15px 0">确认拒绝跟进订单？</p>
      <group>
        <x-textarea
          style="padding-left: 0;padding-right: 0;border: 1px solid #eee"
          title="拒绝原因"
          v-model="rejectRemark"
        ></x-textarea>
      </group>
    </confirm>
    <confirm
      v-model="show3"
      title="提示"
      confirm-text="确定"
      cancel-text="取消"
      @on-confirm="onConfirm3"
    >
      <p style="text-align:left;margin: 15px 0">是否完成订单？</p>
    </confirm>
  </base-order>
</template>

<script>
import baseOrder from "@/views/order/baseOrder";
import {
  finishAdminOrder,
  confirmAdminOrder,
  getAdminOrderDetail,
  finishAdminOrderAllow,
  rejectAdminOrderAllow,
  adminOrderReject
} from "@/api/order";
import { statusEnum } from "./enum";
import { getClientDetail } from "../../api/client";
import { getButtons } from "../../utils/auth";

// import orderMixin from "@/mixin/order";
export default {
  components: { baseOrder },
  name: "salesmanOrder",
  props: {
    id: {
      type: String
    }
  },
  // mixins: [orderMixin],
  data() {
    return {
      statusEnum,
      show: false,
      show1: false,
      show2: false,
      show3: false,
      value: "",
      params: {
        auditName: "",
        auditPhone: "",
        orderId: ""
        // auditStatus: ""
      },
      detail: "",
      allowInfo: "",
      finishRemark: "",
      rejectRemark: "",
      rejectValue: false
    };
  },
  activated() {
    this.getAdminOrderDetail();
  },
  created() {
    const buttons = getButtons();
    if (buttons) {
      for (let i = 0; i < buttons.length; i++) {
        if (buttons[i].children) {
          for (let x = 0; x < buttons[i].children.length; x++) {
            if (buttons[i].children[x].code == "reject_oil_order") {
              this.rejectValue = true;
            }
          }
        }
      }
    }
    this.params.orderId = this.$route.params.id;
    getClientDetail()
      .then(res => {
        this.params.auditName = res.realName;
        this.params.auditPhone = res.phone;
      })
      .catch(err => {
        this.$showError(err);
      });
    this.getAdminOrderDetail();
  },
  methods: {
    getAdminOrderDetail() {
      getAdminOrderDetail({ id: this.$route.params.id })
        .then(res => {
          this.detail = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    onConfirm1() {
      this.finishOrder();
    },
    onConfirm2() {
      if (this.rejectRemark) {
        this.rejectOrder();
      } else {
        this.$showMessage("请填写拒绝原因");
      }
    },
    onConfirm3() {
      this.$vux.loading.show();
      finishAdminOrderAllow({ orderId: this.id })
        .then(res => {
          this.$vux.loading.hide();
          this.allowInfo = res;
          if (res.allowFinish == true) {
            this.finishOrder();
          } else {
            this.show1 = true;
          }
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showMessage(err);
        });
    },
    onConfirm() {
      let result = confirm("确认审核通过订单?");
      if (result) {
        this.$vux.loading.show();
        confirmAdminOrder({ ...this.params, auditStatus: 1 })
          .then(() => {
            this.$vux.loading.hide();
            this.$showError("操作成功");
            this.getAdminOrderDetail();
          })
          .catch(e => {
            this.$vux.loading.hide();
            this.$showError(e);
          });
      }
    },
    onCancel() {
      let result = confirm("确认拒绝订单?");
      if (result) {
        this.$vux.loading.show();
        confirmAdminOrder({ ...this.params, auditStatus: 0 })
          .then(() => {
            this.$vux.loading.hide();
            this.$showError("操作成功");
            this.getAdminOrderDetail();
          })
          .catch(e => {
            this.$vux.loading.hide();
            this.$showError(e);
          });
      }
    },
    reject() {
      rejectAdminOrderAllow({ orderId: this.id })
        .then(res => {
          if (res == true) {
            this.show2 = true;
          } else {
            this.$showMessage("该订单当前无法拒绝");
          }
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    ifFinishOrder() {
      this.show3 = true;
    },
    finishOrder() {
      this.$vux.loading.show();
      finishAdminOrder({ orderId: this.id, finishRemark: this.finishRemark })
        .then(() => {
          this.$vux.loading.hide();
          this.getAdminOrderDetail();
        })
        .catch(e => {
          this.$showError(e);
          this.$vux.loading.hide();
        });
    },
    rejectOrder() {
      this.$vux.loading.show();
      adminOrderReject({ orderId: this.id, remark: this.rejectRemark })
        .then(() => {
          this.$vux.loading.hide();
          this.show2 = false;
          this.$showError("操作成功");
          this.getAdminOrderDetail();
        })
        .catch(e => {
          this.$showError(e);
          this.$vux.loading.hide();
        });
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.propBtn {
  float: right;
  margin: 0 22px 0 10px;
  width: 120px;
}
.block {
  width: 80%;
  height: 420px;
  background-color: #fff;
  border-radius: 8px;
}
.info-body {
  padding: 20px 30px;
}
.order {
  &-status {
    &-wait {
      color: #ff3600;
    }
  }
  &-header {
    display: flex;
  }
}
.oil {
  &-list-item {
    margin-top: 20px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(186, 210, 234, 0.3);
    border-radius: 14px;
    display: flex;
  }
  &-logo {
    flex: none;
    margin-right: 30px;
    img {
      display: block;
      height: 140px;
      width: 140px;
    }
  }
  &-detail {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    &-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 1em;
      color: rgba(17, 17, 17, 1);
    }
    &-spec {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
    }
    &-extra {
      display: flex;
      justify-content: space-between;
      line-height: 1em;
    }
    &-total {
      &-prefix {
        color: #535353;
        font-size: 12px;
      }
      color: #ff3600;
      font-size: 15px;
    }
    &-price {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #525252;
    }
    &-action {
      width: 50px;
      height: 50px;
      background: rgba(246, 246, 246, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
    }
  }
}
</style>
